<script setup lang="ts">
import {
	MenubarSeparator,
	type MenubarSeparatorProps,
	useForwardProps,
} from "reka-ui";
import { twMerge } from "tailwind-merge";
import { computed, type HTMLAttributes } from "vue";

const props = defineProps<
	MenubarSeparatorProps & { class?: HTMLAttributes["class"] }
>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<MenubarSeparator
		:class="twMerge('-mx-1 my-1 h-px bg-muted', props.class)"
		v-bind="forwardedProps"
	/>
</template>
